import * as React from 'react';
const CustomDnbMobileBank = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 32" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="#b3b3b3"
          d="M18 11.5a.5.5 0 0 0 1 0zm1 11a.5.5 0 0 0-1 0zM1.5 1h16V0h-16zm16 30h-16v1h16zM1 30.5v-29H0v29zm17-29v10h1v-10zm0 21v8h1v-8zM1.5 31a.5.5 0 0 1-.5-.5H0A1.5 1.5 0 0 0 1.5 32zm16 1a1.5 1.5 0 0 0 1.5-1.5h-1a.5.5 0 0 1-.5.5zm0-31a.5.5 0 0 1 .5.5h1A1.5 1.5 0 0 0 17.5 0zm-16-1A1.5 1.5 0 0 0 0 1.5h1a.5.5 0 0 1 .5-.5z"
        />
        <path d="M.5 25.5h18" className="custom_dnb_mobile_bank_svg__cls-2" />
        <circle cx={9.5} cy={28.5} r={1} fill="#c4c4c4" />
        <path
          d="M13.5 19v-2c.5.67 2.2 1.5 5 1.5s4.5-.83 5-1.5v2c-.5.67-2.2 1.5-5 1.5s-4.5-.83-5-1.5"
          className="custom_dnb_mobile_bank_svg__cls-4"
        />
        <path
          d="M13.5 17v-2c.5.67 2.2 1.5 5 1.5s4.5-.83 5-1.5v2c-.5.67-2.2 1.5-5 1.5s-4.5-.83-5-1.5"
          className="custom_dnb_mobile_bank_svg__cls-4"
        />
        <path d="M13.5 15c.33-.67 1.8-1.5 5-1.5s4.67.83 5 1.5" className="custom_dnb_mobile_bank_svg__cls-2" />
      </g>
    </g>
  </svg>
);
export default CustomDnbMobileBank;
